import { render } from "./NewEventForm.vue?vue&type=template&id=19dd531a&scoped=true&ts=true"
import script from "./NewEventForm.vue?vue&type=script&lang=ts"
export * from "./NewEventForm.vue?vue&type=script&lang=ts"

import "./NewEventForm.vue?vue&type=style&index=0&id=19dd531a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19dd531a"]])

export default __exports__